export const setAuthentication = (user) => {
    const jsonString = JSON.stringify(user);
    return localStorage.setItem('authenticated', jsonString)
}

export const getAuthenticated = () => {
    const jsonString = localStorage.getItem('authenticated')
    let json = undefined
    if (jsonString) {
        json = JSON.parse(jsonString)
    }
    return json
}

